<convfact-contactbankaccount-form *ngIf="contactUid" [contactUid]="contactUid" [bankAccountUid]="bankAccountUid"
  (saved)="returnToIndex()" (cancelled)="returnToIndex()"></convfact-contactbankaccount-form>